import { BaseModel } from "sjs-base-model";
import configuration from '../../utilities/configuration';
import * as EffectUtility from "../../utilities/EffectUtility";

export async function changeUserPassword(userId, passwords) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath + "/" + userId + "/password";
    return EffectUtility.putToModel(BaseModel, endpoint, passwords);
}
